<template>
  <d-card-body class="p-0 pb-3 text-left">
    <table class="table mb-0 responsive-table">
      <thead class="bg-light">
        <tr>
          <th scope="col" class="border-0 name-cell">Imię i nazwisko</th>
          <th scope="col" class="border-0 amount-cell">Suma</th>
          <th scope="col" class="border-0 payment_type-cell">Typ kosztu</th>
          <th scope="col" class="border-0 recipent-cell">Odbiorca</th>
          <th scope="col" class="border-0 recipent-cell">Spółka</th>
          <th scope="col" class="border-0 title-cell">Tytuł</th>
          <th scope="col" class="border-0 comment-cell">Komentarz</th>
          <th scope="col" class="border-0 action-cell text-center">Akcje</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(expense, index) in expenses"
          :key="expense.id">
          <td>
            <dt>Imię i nazwisko</dt>
            <template v-if="expense.user">
              <dd>{{ expense.user.name }} {{ expense.user.surname }}</dd>
            </template>
          </td>
          <td>
            <dt>Suma</dt>
            <dd>{{ toNumber(expense.amount) }} zł</dd>
          </td>
          <td>
            <dt>Typ kosztu</dt>
            <dd>
              <strong>{{ lang[expense.payment_type] }}</strong>
              <d-checkbox
                class="mt-2 small yes-no"
                v-if="expense.payment_type === 'transfer'"
                :value="'1'"
                :unchecked-value="'0'"
                toggle
                @input="updateExpense(expense)"
                v-model="expense.transfer_complete">
                Zealizowany
              </d-checkbox>
              <d-checkbox
                class="mt-2 small yes-no"
                v-if="expense.payment_type === 'cash'"
                :value="'1'"
                :unchecked-value="'0'"
                @input="updateExpense(expense)"
                toggle
                v-model="expense.cash_refunded">
                Wykonano zwrot
              </d-checkbox>
            </dd>
          </td>
          <td>
            <dt>Odbiorca</dt>
            <dd>
              <strong>{{ expense.expenses_cost_type_name }}</strong><br />
              <template v-if="expense.expenses_cost_type === 1" >
                {{ expense.bailiff ? expense.bailiff.name : 'Komornik usunięty' }}
              </template>
              <template v-else-if="expense.expenses_cost_type === 3">
                {{ expense.recipent }}
              </template>
              <template v-else-if="expense.expenses_cost_type === 2">
                {{ expense.court ? expense.court.name : 'Sąd usunięty' }}
              </template>
            </dd>
          </td>
          <td>
            <dt>Spółka</dt>
            <dd v-if="expense.company_name">{{ expense.company_name }}</dd>
            <dd v-else-if="expense.contract_case_id !== 0 &&  !expense.company_name">Spółka usunięta</dd>
            <dd v-else>Brak</dd>
          </td>
          <td>
            <dt>Tytuł</dt>
            <dd>{{ expense.transfer_title }}</dd>
          </td>
          <td>
            <dt>Komentarz</dt>
            <dd>{{ expense.comment }}</dd>
          </td>
          <td class="text-center">
            <dt>Akcja</dt>
            <dd class="wsnw">
              <slot name="action" v-bind:expense="expense"></slot>
            </dd>
          </td>
        </tr>
        <tr v-if="expenses.length === 0">
          <td colspan="8" class="text-center text-info">
            Brak wydatków do wyświetlenia&hellip;
          </td>
        </tr>
      </tbody>
    </table>

    <ss-pagination
      :meta-data="paginationMetaData"
      :initial-page="currentPage" />
  </d-card-body>
</template>

<script>
import SsPagination from '@/components/common/SsPaginationNew';

export default {
  name: 'ExpenseTableBody',
  components: {
    SsPagination
  },
  props: {
    expenses: Array,
    paginationMetaData: Object,
    currentPage: Number,
    lang: Object,
    actionInProgress: Boolean
  },
  methods: {
    toNumber (number) {
      return Vue.toNumber(number)
    }, 
    updateExpense(expense){
      axios.post('api/expenses/update/' + expense.id, expense).catch((error) => {
        LarErrors.record(error.response.data.errors)
      })
    },
  }
}
</script>
